import React from "react";
import Cards from "./Cards";
import Filter from "./Filter";
class NewsList extends React.Component {

    componentDidMount() {

    }

    render() {
        return (
          <section className="rob-article__list">
              <Filter/>
              <div className="container">
                  <Cards cards={this.props.cards} />
              </div>
          </section>
        )
    }
}

export default NewsList;




// WEBPACK FOOTER //
// ./src/components/elements/NewsList.js